import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "types/store";
import { Button, ButtonGroup } from "aible";
import { toast } from "react-toastify";
// @ts-ignore
import JSONInput from "react-json-editor-ajrm";
// @ts-ignore
import locale from "react-json-editor-ajrm/locale/en";
import IconAgentCustom from "images/agent_custom_icon.png";
import IconAgentAible from "images/agent_aible.svg";
import LabeledToggle from "components/Inputs/Toggle/Toggle";
import { LineInput } from "components/Inputs/LineInput";
import AibleAnywhereBuilder, { AnywhereStep, AnywhereExecutionStep } from "components/ChatGPT/AibleAnywhereBuilder";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as aibleAnywhereReducer from "containers/AibleAnywhere/reducer";
import { getStepTypeFromBackendStep, getBackEndStepIcon } from "containers/AibleAnywhere/reducer";
import * as viewReducer from "containers/View/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as templateReducer from "containers/Templates/reducer";
import * as languagageModelArtifactReducer from "containers/LanguageModelArtifact/reducer";
import * as accountsReducer from "@/containers/Accounts/reducer";
import * as reportReducer from "@/containers/Report/ReportReducer";
import * as foldersReducer from "@/containers/Folders/reducer";
import { getAgentAutonomyView } from "containers/View/reducer";
import { AibleClientFactory } from "client/aible/factory";
import { isEnabled } from "utils/featureFlags";
import styles from "./style.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import AgentAutonomyControls from "components/AgentAutonomy/AgentAutonomyControls";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import NewChatSimpleHeader from "components/NewChat/NewChatSimpleHeader";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";
import { StandardOptions, TaggingOptions } from "@/components/Openshell/SandboxWorkList";
const AibleAgent = ({ nextId, match, history, isNewChat, hideModal }) => {
    const dispatch = useDispatch();
    const agentAutonomyView = useSelector((state) => getAgentAutonomyView(state));
    const [pageType, setPageType] = useState("Builder");
    const [rightPaneType, setRightPaneType] = useState("Step Builder");
    const [showTemplateSetup, updateShowTemplateSetup] = useState(false);
    const [hasAutoOpenedSetup, updateHasAutoOpenedSetup] = useState(false);
    const aaId = match?.params?.agentId ?? "new";
    const viewType = match?.params?.viewType;
    const isTemplateView = viewType === "template";
    const aaProject = { id: aaId, ...useSelector((state) => aibleAnywhereReducer.getBase(state)?.[aaId]) };
    const isLoading = useSelector((state) => aibleAnywhereReducer.getIsLoading(state, "misc"));
    const newAgentName = useSelector((state) => aibleAnywhereReducer.getName(state, aaId));
    const aibleAnywhereProjects = useSelector((state) => aibleAnywhereReducer.getBase(state));
    useEffect(() => {
        if (agentAutonomyView === "LOW" && rightPaneType !== "Step Builder") {
            setRightPaneType("Step Builder");
        }
        if (agentAutonomyView === "MODERATE" && rightPaneType !== "Flow Builder") {
            setRightPaneType("Flow Builder");
        }
    }, [agentAutonomyView]);
    const isOpenShellOrigin = aaProject?.workflowOrigin === "OPENSHELL";
    const isAiqOrigin = aaProject?.workflowOrigin === "AIQ";
    const isGeneratedWorkflow = isOpenShellOrigin || isAiqOrigin;
    useEffect(() => {
        if (isTemplateView && isGeneratedWorkflow && !hasAutoOpenedSetup && !isLoading && !hideModal) {
            updateHasAutoOpenedSetup(true);
            updateShowTemplateSetup(true);
        }
    }, [isTemplateView, isGeneratedWorkflow]);
    return (React.createElement("div", { className: styles.aibleAgentBase },
        React.createElement("div", { className: styles.header },
            React.createElement("div", { className: styles.agentTitle },
                React.createElement(LineInput, { isMediumBox: true, isCleanEditable: true, style: { width: "100%" }, value: newAgentName, onChange: (val) => {
                        dispatch(aibleAnywhereReducer.updateName(aaId, val));
                    } })),
            React.createElement("div", null,
                React.createElement(Button, { style: { padding: "5px 12px", marginRight: "5px", whiteSpace: "nowrap" }, onClick: () => dispatch(aibleAnywhereReducer.saveAibleAnywhere(aaProject, newAgentName, undefined, undefined, undefined, undefined, aaProject?.isOpenShellOrigin ? true : undefined)) }, "Save"),
                React.createElement(Button, { style: { padding: "5px 12px", whiteSpace: "nowrap" }, onClick: () => dispatch(aibleAnywhereReducer.saveAibleAnywhere(aaProject, newAgentName, true, undefined, true, undefined, aaProject?.isOpenShellOrigin ? true : undefined)) }, "Create and Open New Agent"))),
        React.createElement("div", { className: styles.paneHolder, style: { height: "calc(100vh - 110px)" } },
            !isNewChat && (React.createElement("div", { className: styles.leftPane, style: { height: "100%" } },
                aaProject?.messages === undefined || aaProject?.messages.length === 0 ? (React.createElement("div", { className: styles.newChatSimpleHeaderContainer },
                    React.createElement(NewChatSimpleHeader, { messageOverride: isNewChat
                            ? "Let's build your agent step by step"
                            : aaProject?.introMessage?.length > 0
                                ? aaProject?.introMessage
                                : "How can I help you?", aibleSubtitleTextOverride: {} }))) : (React.createElement(Messages, { agent: aaProject })),
                React.createElement(ChatPane, { agent: aaProject }),
                isEnabled("agent-autonomy-controls") && (React.createElement("div", { className: styles.agentControls },
                    React.createElement(AgentAutonomyControls, { isAgentPage: true, history: history }))))),
            React.createElement("div", { className: isNewChat ? styles.rightPaneNewChat : styles.rightPane },
                React.createElement("div", { className: styles.agentHeader },
                    React.createElement("img", { src: IconAgentAible, style: { marginRight: "5px" } }),
                    React.createElement(LineInput, { style: { width: "100%", marginRight: "10px" }, value: newAgentName ?? aaProject?.name ?? "New Agent", onChange: (val) => dispatch(aibleAnywhereReducer.updateName(aaId, val)) })),
                React.createElement("div", { className: styles.agentDescriptionBox },
                    React.createElement("textarea", { className: styles.agentDescriptionTextArea, style: { width: "100%" }, value: aaProject?.description, onChange: (val) => {
                            dispatch(aibleAnywhereReducer.updateDescription(aaId, val?.currentTarget?.value));
                        }, placeholder: "Enter Description" })),
                isLoading === true ? (React.createElement("div", { className: styles.agentLoading },
                    "Generating Agent...",
                    React.createElement(LoadingIndicator, { style: { margin: "0px", marginTop: "20px" } }))) : (React.createElement("div", null,
                    isTemplateView && isOpenShellOrigin && (React.createElement("div", null,
                        React.createElement(Button, { type: "primary", onClick: () => updateShowTemplateSetup(true), style: { marginLeft: "10px", marginTop: "20px" } }, "Use Template Setup"))),
                    React.createElement("div", null,
                        React.createElement(ButtonGroup, { style: { margin: "20px", marginLeft: "10px" } },
                            (!isNewChat ||
                                !isEnabled("agent-autonomy-controls") ||
                                (isNewChat && agentAutonomyView === "LOW")) && (React.createElement(Button, { active: rightPaneType === "Step Builder", onClick: () => setRightPaneType("Step Builder"), style: { padding: "5px" } }, "Step Builder")),
                            !isOpenShellOrigin && (React.createElement(Button, { active: rightPaneType === "Generator", onClick: () => setRightPaneType("Generator"), style: { padding: "5px" } }, "Generator")),
                            React.createElement(Button, { active: rightPaneType === "JSON", onClick: () => setRightPaneType("JSON"), disabled: aaProject === undefined, style: { padding: "5px" } }, "JSON"))),
                    React.createElement("div", null, rightPaneType === "Step Builder" ? (React.createElement(SkillsOverview, { agent: { id: aaId, ...aaProject } })) : rightPaneType === "JSON" ? (React.createElement(AgentCode, { agent: aaProject })) : rightPaneType === "Generator" ? (React.createElement(AibleAnywhereBuilder, null)) : (React.createElement("div", null))),
                    React.createElement("div", null, isNewChat && React.createElement(Messages, { agent: aaProject })))),
                React.createElement("div", { className: styles.showAdvancedSettings },
                    React.createElement("a", { onClick: () => dispatch(aibleAnywhereReducer.updateBase({
                            ...aibleAnywhereProjects,
                            [aaProject?.id]: {
                                ...aibleAnywhereProjects[aaProject?.id],
                                showAdvancedSettings: !aaProject?.showAdvancedSettings
                            }
                        })) }, aaProject?.showAdvancedSettings === true ? "Hide Advanced Settings" : "Show Advanced Settings")),
                aaProject?.showAdvancedSettings === true && (React.createElement("div", { className: styles.advancedSettings },
                    React.createElement("div", { className: styles.includeWarning },
                        React.createElement("input", { style: { marginTop: "0px", marginRight: "3px" }, type: "checkbox", checked: aaProject?.includeWarning === true, onClick: () => dispatch(aibleAnywhereReducer.updateBase({
                                ...aibleAnywhereProjects,
                                [aaProject?.id]: {
                                    ...aibleAnywhereProjects[aaProject?.id],
                                    includeWarning: !aaProject?.includeWarning
                                }
                            })) }),
                        "Include AI hallucination warning"),
                    React.createElement("div", { className: styles.includeWarning, style: { marginTop: "5px" } },
                        React.createElement("input", { style: { marginTop: "0px", marginRight: "3px" }, type: "checkbox", checked: aaProject?.hideInputControls === true, onClick: () => dispatch(aibleAnywhereReducer.updateBase({
                                ...aibleAnywhereProjects,
                                [aaProject?.id]: {
                                    ...aibleAnywhereProjects[aaProject?.id],
                                    hideInputControls: !aaProject?.hideInputControls
                                }
                            })) }),
                        "Hide agent autonomy controls and input box"),
                    React.createElement("div", { className: styles.agentCacheToggle },
                        React.createElement("span", null, "Reduce costs by showing cached responses to matching questions"),
                        React.createElement(LabeledToggle, { style: { display: "block" }, checked: aaProject?.maxCacheAge !== undefined, onChange: () => {
                                dispatch(aibleAnywhereReducer.updateBase({
                                    ...aibleAnywhereProjects,
                                    [aaProject?.id]: {
                                        ...aibleAnywhereProjects[aaProject?.id],
                                        maxCacheAge: aaProject?.maxCacheAge === undefined ? chatGPTReducer.DEFAULT_CACHE_AGE : undefined
                                    }
                                }));
                            }, isAibleColors: true })),
                    aaId !== "new" && isEnabled("aa-frontback-switcher") && (React.createElement("div", { className: styles.runToggle },
                        React.createElement("span", { style: { fontWeight: "bold", marginRight: "5px" } }, "Run Agent on: "),
                        React.createElement(ButtonGroup, null,
                            React.createElement(Button, { style: { padding: "6px" }, active: aaProject?.runToggle === "BACKEND", onClick: () => dispatch(aibleAnywhereReducer.updateRunToggle(aaId, "BACKEND")) }, "Backend"),
                            React.createElement(Button, { style: { padding: "6px" }, active: aaProject?.runToggle !== "BACKEND", onClick: () => dispatch(aibleAnywhereReducer.updateRunToggle(aaId, "FRONTEND")) }, "Frontend")))))))),
        isTemplateView && isOpenShellOrigin && (React.createElement(WorkflowTemplateSetupModal, { showModal: showTemplateSetup, updateShowModal: updateShowTemplateSetup, agent: aaProject }))));
};
export const SkillsOverview = ({ agent, listStepsOnly, editOnly, updateWorkflowSource, isTemplateSetup, wrapperStyleOverride }) => {
    const dispatch = useDispatch();
    const [updatePrompt, setUpdatePrompt] = useState("");
    const [stepModal, setStepModal] = useState(undefined);
    const [stepExecutionModal, setExecutionStepModal] = useState(undefined);
    const aibleAnywhereProjects = useSelector((state) => aibleAnywhereReducer.getBase(state));
    const datasets = useSelector((state) => homeReducer.getDatasets(state));
    const artifacts = useSelector((state) => languagageModelArtifactReducer.getArtifactList(state, "CORPUS"));
    const blueprints = useSelector((state) => viewReducer.getChatBlueprints(state));
    const agentIQToolOptions = useSelector((state) => chatGPTReducer.getAgentIQToolOptions());
    const currentModel = useSelector((state) => chatGPTReducer.getModelId(state));
    const templates = useSelector((state) => templateReducer.getBase(state));
    const [slackChannels, updateSlackChannels] = useState(undefined);
    const accountId = useSelector((state) => accountsReducer.getSelectedAccountId(state));
    const fetchSlackTools = async () => {
        try {
            const factory = await AibleClientFactory.getInstance().getAccountClient().getCustomerClientFactory(accountId);
            const tools = await factory.getCompletionClient().getTools();
            updateSlackChannels(tools);
            console.log("what is slackChannels", tools);
        }
        catch (error) {
            console.error("Error fetching items:", error);
        }
    };
    useEffect(() => {
        fetchSlackTools();
    }, []);
    const addStep = () => dispatch(aibleAnywhereReducer.updateBase({
        ...aibleAnywhereProjects,
        [agent?.id]: {
            ...aibleAnywhereProjects[agent?.id],
            steps: [...(aibleAnywhereProjects[agent?.id]?.steps ?? []), { ModelId: currentModel }]
        }
    }));
    const addExecutionStep = () => {
        if (updateWorkflowSource !== undefined) {
            return updateWorkflowSource({
                ...agent,
                execution_steps: [...(agent?.execution_steps ?? []), {}]
            });
        }
        dispatch(aibleAnywhereReducer.updateBase({
            ...aibleAnywhereProjects,
            [agent?.id]: {
                ...aibleAnywhereProjects[agent?.id],
                execution_steps: [...(aibleAnywhereProjects[agent?.id]?.execution_steps ?? []), {}]
            }
        }));
    };
    function swap(arr, i, j) {
        const newArr = [...arr];
        [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
        return newArr;
    }
    const hasNewBackendSteps = agent?.execution_steps !== undefined && agent?.runToggle === "BACKEND";
    // Since we don't currently have a way to fetch sandbox name/targets for send_openclaw_message tool, we are storing
    // state for them as options so user can modify the steps and still have access to modifying steps and adding them.
    const [initialChannelTargets, updateInitialChannelTargets] = useState([]);
    const [initialSandbox, updateInitialSandbox] = useState();
    const checkAndUpdateInitialChannelTargetsSandbox = () => {
        const channelTargets = new Set();
        for (const executionStep of agent?.execution_steps ?? []) {
            if (executionStep?.communication_tool?.id === 21) {
                if (executionStep?.communication_tool?.target) {
                    channelTargets.add(executionStep?.communication_tool?.target);
                }
                // Assumption that only one sandbox was used for workflow generation
                if (!initialSandbox && executionStep?.communication_tool?.sandbox_name) {
                    updateInitialSandbox(executionStep?.communication_tool?.sandbox_name);
                }
            }
        }
        updateInitialChannelTargets([...channelTargets]);
    };
    // Had to use a useEffect for this...
    useEffect(() => {
        checkAndUpdateInitialChannelTargetsSandbox();
    }, [agent?.id]);
    return (React.createElement("div", { className: listStepsOnly || editOnly || isTemplateSetup ? styles.skillsOverviewSetup : styles.skillsOverview, style: wrapperStyleOverride },
        stepModal !== undefined && (React.createElement(AgentStepModal, { agent: agent, step: agent?.steps?.[stepModal], index: stepModal, setStepModal: setStepModal })),
        stepExecutionModal !== undefined && (React.createElement(AgentExecutionStepModal, { agent: agent, step: agent?.execution_steps?.[stepExecutionModal], index: stepExecutionModal, setStepModal: setExecutionStepModal, slackChannels: slackChannels, updateWorkflowSource: updateWorkflowSource, initialChannelTargets: initialChannelTargets, initialSandbox: initialSandbox })),
        React.createElement("div", { className: listStepsOnly || editOnly ? undefined : styles.skillsBox, style: isTemplateSetup ? { maxHeight: "unset" } : undefined },
            !listStepsOnly && !editOnly && (React.createElement(Button, { onClick: () => {
                    if ((agent?.executionId === undefined || agent?.runToggle === "FRONTEND") &&
                        updateWorkflowSource === undefined) {
                        addStep();
                        setStepModal((agent?.steps ?? []).length);
                    }
                    else {
                        addExecutionStep();
                        setExecutionStepModal((agent?.execution_steps ?? []).length);
                    }
                } }, "+ Add Step")),
            hasNewBackendSteps
                ? agent.execution_steps.map((step, index) => {
                    const foundToolById = agentIQToolOptions.find((t) => t?.id === step?.tool?.id);
                    return (React.createElement(BackendAgentStep, { key: `backendStep__${index}__${step?.id}`, listStepsOnly: listStepsOnly, step: step, index: index, setExecutionStepModal: setExecutionStepModal, foundTool: foundToolById, slackChannels: slackChannels }));
                })
                : agent?.execution_steps !== undefined && agent?.runToggle === "BACKEND"
                    ? agent.execution_steps.map((eStep, i) => {
                        const foundToolByName = agentIQToolOptions.find((t) => t?.value === eStep?.tool_name);
                        const foundTool = foundToolByName === undefined
                            ? (agent?.tool_list ?? []).find((t) => t.name === eStep?.tool_name)
                            : (agent?.tool_list ?? []).find((t) => Number(t.id) === Number(foundToolByName?.id));
                        const foundBlueprint = (blueprints ?? []).find((b) => b?.id === foundTool?.blueprint_id);
                        const foundArtifact = artifacts?.find((a) => a?.id === eStep?.input_args?.doc_id);
                        const stepType = getStepTypeFromBackendStep(eStep?.tool_name);
                        return (React.createElement(OldBackendAgentStep, { key: `oldBackendStep__${i}__${stepType ? stepType : ""}`, listStepsOnly: listStepsOnly, step: eStep, index: i, stepType: stepType, foundBlueprint: foundBlueprint, foundArtifact: foundArtifact, setExecutionStepModal: setExecutionStepModal }));
                    })
                    : agent?.steps !== undefined &&
                        agent?.steps.map((aStep, i) => {
                            const sArtifact = (artifacts ?? []).filter((a) => a.id === aStep?.ArtifactId)?.[0];
                            const fixArtifactId = String(aStep?.ArtifactId ?? "").indexOf("UPLOADED_FILE_STEP_") !== -1
                                ? String(aStep?.ArtifactId ?? "").replace("UPLOADED_FILE_STEP_", "Attached File from Step: ")
                                : aStep?.ArtifactId;
                            return (React.createElement("div", { key: i, className: (listStepsOnly ? styles.agentStepNoHover : styles.agentStep) +
                                    " " +
                                    (aStep?.isHide ? styles.agentStepHide : ""), onClick: listStepsOnly ? undefined : () => setStepModal(i) },
                                React.createElement("div", { className: styles.aStepActions },
                                    React.createElement(ButtonGroup, null,
                                        React.createElement(Button, { style: { padding: "5px" }, onClick: (e) => {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                dispatch(aibleAnywhereReducer.updateBase({
                                                    ...aibleAnywhereProjects,
                                                    [agent?.id]: {
                                                        ...aibleAnywhereProjects[agent?.id],
                                                        steps: swap(agent?.steps, i, i - 1)
                                                    }
                                                }));
                                            }, disabled: i === 0 },
                                            React.createElement(FontAwesomeIcon, { icon: faChevronUp })),
                                        React.createElement(Button, { style: { padding: "5px" }, onClick: (e) => {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                dispatch(aibleAnywhereReducer.updateBase({
                                                    ...aibleAnywhereProjects,
                                                    [agent?.id]: {
                                                        ...aibleAnywhereProjects[agent?.id],
                                                        steps: swap(agent?.steps, i, i + 1)
                                                    }
                                                }));
                                            }, disabled: i >= agent?.steps?.length - 1 },
                                            React.createElement(FontAwesomeIcon, { icon: faChevronDown })),
                                        React.createElement(Button, { style: { padding: "5px" }, onClick: (e) => {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                let newSteps = [...agent.steps];
                                                newSteps[i] = { ...newSteps[i], isHide: aStep?.isHide === true ? false : true };
                                                dispatch(aibleAnywhereReducer.updateBase({
                                                    ...aibleAnywhereProjects,
                                                    [agent?.id]: {
                                                        ...aibleAnywhereProjects[agent?.id],
                                                        steps: newSteps
                                                    }
                                                }));
                                            } }, aStep.isHide === true ? "Show" : "Hide"))),
                                React.createElement("div", { className: styles.aStepHeader },
                                    React.createElement("div", { className: styles.aStepIconWrapper },
                                        React.createElement("img", { src: getBackEndStepIcon(aStep?.Type) })),
                                    React.createElement("div", { className: styles.aStepTitleWrapper },
                                        React.createElement("div", { className: styles.aStepNumberLabel }, `Agent Step ${i + 1}:`),
                                        React.createElement("div", { className: styles.aStepType }, aStep?.Type))),
                                aStep?.Type !== "Attach File" && aStep?.Type !== "Upload File" && (React.createElement("div", { className: styles.aStepDescription }, aStep?.Prompt)),
                                aStep?.DatasetId !== undefined && (aStep?.Type === "Analytics" || aStep?.Type === "NLQ") && (React.createElement("div", { className: styles.aStepExtra },
                                    React.createElement("span", null, "Dataset: "),
                                    React.createElement("span", { style: { fontWeight: "bold" } }, datasets?.[aStep?.DatasetId]?.label + " (" + aStep?.DatasetId + ")"))),
                                aStep?.Dataset_Id_1 !== undefined && (React.createElement("div", { className: styles.aStepExtra },
                                    React.createElement("span", null, "Dataset 1: "),
                                    React.createElement("span", { style: { fontWeight: "bold" } }, datasets?.[aStep?.Dataset_Id_1]?.label + " (" + aStep?.Dataset_Id_1 + ")"))),
                                aStep?.Dataset_Id_2 !== undefined && (React.createElement("div", { className: styles.aStepExtra },
                                    React.createElement("span", null, "Dataset 2: "),
                                    React.createElement("span", { style: { fontWeight: "bold" } }, datasets?.[aStep?.Dataset_Id_2]?.label + " (" + aStep?.Dataset_Id_2 + ")"))),
                                aStep?.ProjectId !== undefined && aStep?.Type === "Prediction" && (React.createElement("div", { className: styles.aStepExtra },
                                    React.createElement("span", null, "Project: "),
                                    React.createElement("span", { style: { fontWeight: "bold" } }, aStep?.ProjectId))),
                                aStep?.TemplateId !== undefined && aStep?.Type === "Optimize" && (React.createElement("div", { className: styles.aStepExtra },
                                    React.createElement("span", null, "Template: "),
                                    React.createElement("span", { style: { fontWeight: "bold" } }, templates?.[aStep?.TemplateId]?.name ?? aStep?.TemplateId))),
                                aStep?.ArtifactId !== undefined && aStep?.Type === "Document Summary" && (React.createElement("div", { className: styles.aStepExtra },
                                    React.createElement("span", null, "Document Set: "),
                                    React.createElement("span", { style: { fontWeight: "bold" } }, sArtifact !== undefined ? sArtifact.name + " (" + aStep?.ArtifactId + ")" : fixArtifactId)))));
                        }))));
};
const BackendAgentStep = ({ listStepsOnly, step, index, setExecutionStepModal, foundTool, slackChannels }) => {
    const dispatch = useDispatch();
    const datasets = useSelector((state) => homeReducer.getDatasets(state));
    const stepLabel = aibleAnywhereReducer.getBackendStepLabel(step, foundTool);
    const artifacts = useSelector((state) => languagageModelArtifactReducer.getArtifactList(state, "CORPUS"));
    const blueprints = useSelector((state) => viewReducer.getChatBlueprints(state));
    const foundBlueprint = (blueprints ?? []).find((b) => b?.id === foundTool?.blueprint_id);
    const foundArtifact = artifacts?.find((a) => a?.id === step?.input_args?.doc_id);
    const isSynthesisStep = step?.type === "synthesize";
    const hasSlackTool = step?.communication_tool !== undefined && step?.communication_tool?.id === 11;
    const hasSendMessageTool = step?.communication_tool !== undefined && step?.communication_tool?.id === 21;
    const slackChannelOptions = (slackChannels ?? []).map((sc) => ({
        label: sc?.config?.channel_id,
        value: sc?.id
    }));
    const selectedSlackChannel = slackChannelOptions.find((option) => option?.value === step?.communication_tool?.third_party_tool_id) ?? null;
    const [hasFetchedPredictProject, updateHasFetchedPredictProject] = useState(false);
    const [isFetchingProjectReport, updateIsFetchingProjectReport] = useState(false);
    const isPredictStep = step?.tool?.id === 10 || foundTool?.id === 10;
    const nexts = useSelector((state) => nextReducer.getBase(state));
    const projectOptions = nexts
        ? Object.keys(nexts)
            .filter((n) => nexts[n]?.projectId !== undefined)
            .map((n) => ({
            label: `${nexts[n]?.reportLabel} (${nexts[n]?.projectId})`,
            value: nexts[n]?.projectId
        }))
        : [];
    const hasPredictProjectId = step?.input_args?.project_id !== undefined;
    const selectedPredictProject = projectOptions?.find((d) => Number(d.value) === step?.input_args?.project_id);
    const folderId = useSelector((state) => foldersReducer.getSelectedFolder(state));
    const shouldFetchPredictProject = hasPredictProjectId &&
        !hasFetchedPredictProject &&
        !selectedPredictProject &&
        isPredictStep &&
        folderId !== undefined;
    const fetchCurrentProjectReport = async (projectId) => {
        updateIsFetchingProjectReport(true);
        try {
            await dispatch(reportReducer.fetchReportByProjectId(projectId));
        }
        catch {
            console.log(`Error fetching associated report for projectId: ${projectId}`);
        }
        finally {
            updateIsFetchingProjectReport(false);
        }
    };
    useEffect(() => {
        if (shouldFetchPredictProject) {
            updateHasFetchedPredictProject(true);
            fetchCurrentProjectReport(step?.input_args?.project_id);
        }
    }, [shouldFetchPredictProject]);
    return (React.createElement("div", { className: listStepsOnly ? styles.agentStepNoHover : styles.agentStep, onClick: listStepsOnly ? undefined : () => setExecutionStepModal(index) },
        React.createElement("div", { className: styles.aStepHeader },
            React.createElement("div", { className: styles.aStepIconWrapper },
                React.createElement("img", { src: getBackEndStepIcon(stepLabel) })),
            React.createElement("div", { className: styles.aStepTitleWrapper },
                React.createElement("div", { className: styles.aStepNumberLabel }, `Agent Step ${index + 1}:`),
                React.createElement("div", { className: styles.aStepType }, stepLabel ?? ""))),
        step?.input_args?.dataset_id !== undefined && (React.createElement("div", { className: styles.aStepExtra },
            React.createElement("span", null, "Dataset: "),
            React.createElement("span", { style: { fontWeight: "bold" } }, datasets?.[step?.input_args?.dataset_id]?.label + " (" + step?.input_args?.dataset_id + ")"))),
        step?.input_args?.project_id !== undefined && (React.createElement("div", { className: styles.aStepExtra }, isFetchingProjectReport ? (React.createElement("div", { className: "flex flex-col items-center" },
            React.createElement(LoadingIndicator, { style: { scale: "0.6" } }),
            "Loading Details")) : (React.createElement(React.Fragment, null,
            React.createElement("span", null, "Project: "),
            React.createElement("span", { style: { fontWeight: "bold" } }, selectedPredictProject ? selectedPredictProject?.label : `(${step?.input_args?.project_id})`))))),
        step?.input_args?.doc_id !== undefined && (React.createElement("div", { className: styles.aStepExtra },
            React.createElement("span", null, "Document Set: "),
            React.createElement("span", { style: { fontWeight: "bold" } }, `${foundArtifact?.name ?? ""} (${step?.input_args?.doc_id})`))),
        foundBlueprint !== undefined && (React.createElement("div", { className: styles.aStepExtra },
            React.createElement("span", null, "Agent Template: "),
            React.createElement("span", { style: { fontWeight: "bold" } }, foundBlueprint?.name))),
        isSynthesisStep && hasSlackTool && (React.createElement("div", { className: styles.aStepExtra },
            React.createElement("span", null, "Publish Report to Slack Channel: "),
            React.createElement("span", { style: { fontWeight: "bold" } }, selectedSlackChannel?.label ?? "No Channel Selected"))),
        hasSendMessageTool && (React.createElement("div", { className: styles.aStepExtra },
            React.createElement("span", null, "Send Message to Communication Channel: "),
            React.createElement("span", { style: { fontWeight: "bold" } }, step?.communication_tool?.target ?? "No Communication Channel Selected"))),
        step?.input_template && (React.createElement("div", { className: styles.aStepExtra },
            React.createElement("span", null, step?.input_template)))));
};
const OldBackendAgentStep = ({ listStepsOnly, step, index, stepType, foundBlueprint, foundArtifact, setExecutionStepModal }) => {
    const datasets = useSelector((state) => homeReducer.getDatasets(state));
    return (React.createElement("div", { className: listStepsOnly ? styles.agentStepNoHover : styles.agentStep, onClick: listStepsOnly ? undefined : () => setExecutionStepModal(index) },
        React.createElement("div", { className: styles.aStepHeader },
            React.createElement("div", { className: styles.aStepIconWrapper },
                React.createElement("img", { src: getBackEndStepIcon(stepType) })),
            React.createElement("div", { className: styles.aStepTitleWrapper },
                React.createElement("div", { className: styles.aStepNumberLabel }, `Agent Step ${index + 1}:`),
                React.createElement("div", { className: styles.aStepType }, stepType ?? ""))),
        step?.input_args?.dataset_id !== undefined && (React.createElement("div", { className: styles.aStepExtra },
            React.createElement("span", null, "Dataset: "),
            React.createElement("span", { style: { fontWeight: "bold" } }, datasets?.[step?.input_args?.dataset_id]?.label + " (" + step?.input_args?.dataset_id + ")"))),
        step?.input_args?.model_id !== undefined && (React.createElement("div", { className: styles.aStepExtra },
            React.createElement("span", null, "Model: "),
            React.createElement("span", { style: { fontWeight: "bold" } }, step?.input_args?.model_id))),
        step?.input_args?.doc_id !== undefined && (React.createElement("div", { className: styles.aStepExtra },
            React.createElement("span", null, "Document Set: "),
            React.createElement("span", { style: { fontWeight: "bold" } }, `${foundArtifact?.name ?? ""} (${step?.input_args?.doc_id})`))),
        foundBlueprint !== undefined && (React.createElement("div", { className: styles.aStepExtra },
            React.createElement("span", null, "Agent Template: "),
            React.createElement("span", { style: { fontWeight: "bold" } }, foundBlueprint?.name)))));
};
const AgentStepModal = ({ agent, step, index, setStepModal }) => {
    console.log("AgentStepModal agent", agent);
    return (React.createElement(Dialog, { open: true, onOpenChange: () => setStepModal(undefined) },
        React.createElement(DialogContent, null,
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, "Edit Step")),
            React.createElement(AnywhereStep, { step: step, index: index, aaId: agent?.id, userPrompt: agent?.prompt, isModal: true, setStepModal: setStepModal }),
            React.createElement(DialogFooter, null,
                React.createElement(Button, { type: "primary", onClick: () => setStepModal(undefined), style: { marginLeft: "auto" } }, "Save")))));
};
const AgentExecutionStepModal = ({ agent, step, index, setStepModal, slackChannels, updateWorkflowSource, initialChannelTargets, initialSandbox }) => {
    console.log("AgentStepModal agent", agent);
    return (React.createElement(Dialog, { open: true, onOpenChange: () => setStepModal(undefined) },
        React.createElement(DialogContent, null,
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, "Edit Step")),
            React.createElement(AnywhereExecutionStep, { step: step, index: index, agent: agent, userPrompt: agent?.prompt, isModal: true, setStepModal: setStepModal, slackChannels: slackChannels, updateWorkflowSource: updateWorkflowSource, initialChannelTargets: initialChannelTargets, initialSandbox: initialSandbox }),
            React.createElement(DialogFooter, null,
                React.createElement(Button, { type: "primary", onClick: () => setStepModal(undefined), style: { marginLeft: "auto" } }, "Save")))));
};
export const AgentCode = ({ agent }) => {
    const dispatch = useDispatch();
    const [isImportJSON, updateIsImportJSON] = useState(false);
    const [importJSON, updateImportJSON] = useState(undefined);
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.agentCode },
            React.createElement(JSONInput, { viewOnly: true, id: "JSONQueryInput", placeholder: {
                    ["Agent Steps"]: agent?.executionId !== undefined && agent?.execution_steps ? agent?.execution_steps : agent?.steps
                }, locale: locale, height: "100%", width: "100%", confirmGood: false })),
        React.createElement("div", { className: styles.agentCodeActions, style: { margin: "20px" } },
            React.createElement(Button, { style: { marginRight: "10px" }, onClick: () => {
                    toast("Blueprint copied to clipboard.", {
                        type: toast.TYPE.SUCCESS,
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3500
                    });
                    const { id, ...jAgent } = agent ?? {};
                    navigator.clipboard.writeText(JSON.stringify(jAgent));
                } }, "Export JSON"),
            React.createElement(Button, { onClick: () => updateIsImportJSON(true) }, "Import JSON")),
        isImportJSON === true && (React.createElement("div", { className: styles.agentImport },
            React.createElement("input", { type: "text", style: { width: "calc(100% - 40px)", marginBottom: "10px" }, onChange: (e) => updateImportJSON(e?.currentTarget?.value) }),
            React.createElement("div", { className: styles.agentImportActions },
                React.createElement(Button, { onClick: () => updateIsImportJSON(false) }, "Cancel"),
                React.createElement(Button, { onClick: () => dispatch(aibleAnywhereReducer.saveAibleAnywhere(JSON.parse(importJSON), importJSON?.name ?? "Aible Agent Import", true, undefined, true)) }, "Import"))))));
};
const Messages = ({ agent }) => {
    const [showSentIndices, updateShowSentIndices] = useState({});
    return (React.createElement("div", { className: styles.agentMessages, id: "agent_message_scroll" }, agent?.messages !== undefined &&
        agent?.messages.map((m, i) => (React.createElement("div", { key: i, className: styles.agentMessage, style: i % 2 !== 0 ? { background: "rgb(247, 245, 250)" } : {} },
            React.createElement("div", { className: styles.agentMessageBody },
                React.createElement("img", { src: agent?.isAibleAgent ? IconAgentAible : IconAgentCustom, style: { height: "16px", width: "16px", marginRight: "5px" } }),
                React.createElement("span", { style: { fontWeight: "bold" } }, m?.text)),
            (m?.prompt !== undefined || m?.response !== undefined) && (React.createElement("a", { onClick: () => updateShowSentIndices({ ...showSentIndices, [i]: !showSentIndices?.[i] }) }, (showSentIndices[i] === true ? "Hide " : "Show ") + (m?.prompt !== undefined ? "prompt" : "response"))),
            m?.prompt !== undefined && showSentIndices[i] === true && (React.createElement("div", { className: styles.messageExtra },
                React.createElement("div", null, "Prompt: "),
                React.createElement("p", { style: { color: "#666" }, dangerouslySetInnerHTML: { __html: m.prompt.replace(/\n/g, "<br />") } }))),
            m?.response !== undefined && showSentIndices[i] === true && (React.createElement("div", { className: styles.messageExtra },
                React.createElement("div", null, "LLM Response: "),
                React.createElement("p", { style: { color: "#666" }, dangerouslySetInnerHTML: { __html: m.response.replace(/\n/g, "<br />") } }))))))));
};
let audioContext;
let recorder;
export const VoiceButton = ({ setUserPrompt, onUploadComplete }) => {
    const [isLoading, setIsLoading] = useState(false);
    const handleVoiceTest = async () => {
        setIsLoading(true);
        audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const RecorderModule = require("recorder-js");
        const Recorder = RecorderModule.default;
        const recorder = new Recorder(audioContext);
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            recorder.init(stream);
            await recorder.start();
            setTimeout(async () => {
                const { blob } = await recorder.stop();
                const wavBlob = new Blob([blob], { type: "audio/wav" });
                const url = URL.createObjectURL(wavBlob);
                const formData = new FormData();
                formData.append("file", wavBlob, "your_audio_file.wav");
                formData.append("response_format", "text");
                const response = await fetch("http://ec2-52-55-255-31.compute-1.amazonaws.com:8000/v1/audio/transcriptions", {
                    method: "POST",
                    body: formData
                });
                const result = await response.text();
                const resultJson = JSON.parse(result);
                console.log("Upload result:", result);
                setUserPrompt(resultJson?.text);
                setIsLoading(false);
            }, 6000);
        }
        catch (err) {
            console.error("Recording error:", err);
            setIsLoading(false);
        }
    };
    return (React.createElement("div", null,
        React.createElement(Button, { onClick: handleVoiceTest, isLoading: isLoading }, isLoading ? "Recording..." : "Voice Input")));
};
const ChatPane = ({ agent }) => {
    const dispatch = useDispatch();
    const [userPrompt, setUserPrompt] = useState(agent?.prompt ?? "");
    const isLoading = useSelector((state) => aibleAnywhereReducer.getIsLoading(state, "misc"));
    const handleAgentSubmit = async () => {
        if (!isLoading) {
            if (agent?.original_tool_list !== undefined &&
                JSON.stringify(agent?.tool_list) !== JSON.stringify(agent?.original_tool_list)) {
                const shouldSave = confirm("You have updated the steps but have not saved the Agent. Would you like to save before continuing?");
                if (shouldSave === true) {
                    dispatch(aibleAnywhereReducer.updateIsLoading("misc", true));
                    await dispatch(aibleAnywhereReducer.saveAibleAnywhere(agent, agent?.name));
                    dispatch(aibleAnywhereReducer.updateIsLoading("misc", false));
                }
            }
            console.log("what is agent?", agent);
            if (agent?.executionId !== undefined && agent?.runToggle === "BACKEND") {
                return dispatch(chatGPTReducer.handleAgentIQ(userPrompt, true, "step-by-step", agent?.executionId, agent?.id));
            }
            dispatch(chatGPTReducer.handleAibleAnywhereSteps(agent, userPrompt));
        }
    };
    return (React.createElement("div", { className: styles.newChatActionsWrapper, style: isEnabled("agent-autonomy-controls") ? {} : { bottom: "30px" } },
        React.createElement("div", { className: styles.newChatActions, style: {
                boxShadow: `0px 0px 7px rgb(133, 86, 235)`,
                border: `1px solid rgb(133, 86, 235)`
            }, id: "chat-message-box" },
            React.createElement("textarea", { className: styles.chatPrompt, value: userPrompt, onChange: (val) => setUserPrompt(val.target.value), placeholder: agent?.inputPlaceholder?.length > 0 ? agent?.inputPlaceholder : "What would you like to do?", autoFocus: true, onKeyDown: (e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                        e.preventDefault();
                        handleAgentSubmit();
                    }
                } }),
            React.createElement("div", { className: styles.botActions },
                isEnabled("agent-voice") ? React.createElement(VoiceButton, { setUserPrompt: setUserPrompt }) : React.createElement("div", null),
                React.createElement(Button, { style: {
                        fontSize: "13px"
                    }, type: "Primary", onClick: async () => handleAgentSubmit(), isLoading: isLoading },
                    "Ask",
                    React.createElement(FontAwesomeIcon, { icon: faArrowRight, style: { marginLeft: "10px", marginTop: "-1px" } }))))));
};
const WorkflowTemplateSetupModal = ({ showModal, updateShowModal, agent }) => {
    const dispatch = useDispatch();
    const agentSettings = {
        name: agent?.name,
        description: agent?.description,
        tags: agent?.tags,
        introMessage: agent?.introMessage ?? "",
        inputPlaceholder: agent?.inputPlaceholder ?? ""
    };
    const [templateSettings, updateTemplateSettings] = useState(agentSettings);
    const [isCreatingAgent, updateIsCreatingAgent] = useState(false);
    const updateSettingsByKey = (key, val) => {
        const stateUpdate = {
            ...templateSettings,
            [key]: val
        };
        updateTemplateSettings(stateUpdate);
    };
    const handleSaveWorkflow = () => {
        updateIsCreatingAgent(true);
        try {
            const retOptions = {
                ...templateSettings,
                saveToMyWork: true
            };
            dispatch(aibleAnywhereReducer.saveGeneratedWorkflow(agent, true, retOptions));
        }
        catch {
            console.log("Error Saving Workflow:", agent, agent?.executionId);
        }
        finally {
            updateIsCreatingAgent(false);
        }
    };
    return (React.createElement(Dialog, { open: showModal, onOpenChange: () => updateShowModal(false) },
        React.createElement(DialogContent, null,
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, `${agent?.name} Setup`)),
            React.createElement(WorkflowTemplateSetupOptions, { agent: agent, settings: templateSettings, updateSettings: updateSettingsByKey }),
            React.createElement(DialogFooter, null,
                React.createElement("div", { className: styles.botActions },
                    React.createElement(Button, { onClick: () => updateShowModal(false) }, "Cancel"),
                    React.createElement(Button, { type: "primary", onClick: () => {
                            handleSaveWorkflow();
                            updateShowModal(false);
                        }, isLoading: isCreatingAgent }, "Create Agent"))))));
};
const WorkflowTemplateSetupOptions = ({ agent, settings, updateSettings }) => {
    return (React.createElement("div", { className: styles.workflowSetupContainer },
        React.createElement(StandardOptions, { sourceState: settings, updateStateByKey: updateSettings }),
        React.createElement(SkillsOverview, { agent: agent, isTemplateSetup: true }),
        React.createElement(TemplateIntroSettings, { settings: settings, updateSettings: updateSettings }),
        React.createElement(TaggingOptions, { sourceState: settings, updateStateByKey: updateSettings })));
};
export const TemplateIntroSettings = ({ settings, updateSettings }) => {
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement("div", null, "Agent Intro Message"),
            React.createElement("div", null,
                React.createElement(LineInput, { placeholder: "Include an initial message to help describe how to use this agent or what type of questions to ask.", value: settings?.introMessage, onChange: (val) => updateSettings("introMessage", val), updateInstant: true }))),
        React.createElement("div", null,
            React.createElement("div", null, "Chat Input Placeholder"),
            React.createElement("div", null,
                React.createElement(LineInput, { placeholder: "Use a custom placeholder for the chat input", value: settings?.inputPlaceholder, onChange: (val) => updateSettings("inputPlaceholder", val), updateInstant: true })))));
};
export default AibleAgent;
